/*
 * @Author: zhaosujuan zhaosujuan@freedodata.com
 * @Date: 2022-10-25 17:09:53
 * @LastEditors: zhaosujuan zhaosujuan@freedodata.com
 * @LastEditTime: 2022-11-10 13:42:12
 * @FilePath: \lyws-official-websit\src\components\solution\data.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const provideServices = [
    {title:'多级管理业务架构',detail:'根据不同项目情况，可分别满足开发区级、园区级、企业级、用户级多种业务场景，方便信息收集上传和政策指令下达。',icon:'iconfont icon-icon-duoji'},
    {title:'统一企业服务和管理门户',detail:'统一各类面向企业侧的服务入口、面向管理侧的管理后台，打破各子系统数据隔阂，让服务更便捷，让管理更高效。',icon:'iconfont icon-icon-tongyiqiye'},
    {title:'园区服务运营数智化',detail:'覆盖企业服务、产业服务、生活服务、物业服务在内的多种服务场景，协助园区沉淀服务经验，提升园区服务品质。',icon:'iconfont icon-icon-yunyingzhihua'},
    {title:'园区经营管理数智化',detail:'覆盖园区资产管理、招商管理、企业（客户）管理、财务管理、园区宣传等经营场景，赋能员工高效协同，提升经营组织效率。',icon:'iconfont icon-icon-guanlizhihua'},
    {title:'园区综合运营管理数智化',detail:'集成Iot设备，覆盖安防管理、环境管理、通行管理、设施管理在内的多种运维管理业务，帮助提升园区综合运管效率。',icon:'iconfont icon-icon-yunyingguanlizhihua'},
    {title:'园区数据决策中心',detail:'整合园区经营、园区服务、园区综合运管的数据沉淀，深度挖掘数据规律和分析数据趋势，为领导的决策提供数据支撑。',icon:'iconfont icon-icon-juecezhongxin'},
]
export const caseList = [
	{
		name: '智慧开发区',
		instructions: '围绕开发区/高新区/经开区/工业园/经济园区等大型园区在招商引资、重大项目推进落地、园区开发建设、统筹管理与安商稳商服务等方面的核心特征，构建 “引、研、跟、落、管、服”六位一体的综合解决方案。',
		url: 'static/images/solution/e68c5688adfcc575.jpg',
		hoverThis: false
	},{
		name: '智慧园区',
		instructions: ' 智慧园区是在Al、云计算、边缘计算、大数据、物联网等新一代信息技术加速突破的态势下,基于人、机物深度融合产生的一种高层级园区发展形态,它具备超高速、大容量的信息通信网络,拥有多维感知、数据驱动、智能决策能力,可与实体空间精准映射、智能交互、虚实融合实现数字孪生,进而为园区运营方、入驻企业和员工提供全天候、全要素、全场景的个性化和精准化服务。',
		url: 'static/images/solution/smart-park.png',
		hoverThis: true
	},{
		name: '智慧楼宇',
		instructions: '借助移动互联网+IOT技术，重构企业服务体系，建立楼宇运营方、企业、员工、商户、第三方机构和智能化设备之间的强链接关系，让用户拥有极致的现代科技办公体验，使服务获取更便捷，最大限度盘活空间和服务资源。',
		url: 'static/images/solution/e26acfb449d276d1.jpg',
		hoverThis: true
	}
]
export const provideDetailList = [
	{
		serviceImg: 'static/images/solution/_203d911d95.jpg',
		serviceName: '多级管理业务架构',
		serviceDetail: 'GOBC、OBC业务架构，按需选择。可分别满足开发区级、园区级、企业级、用户级多种业务场景，方便信息收集上传和政策下达。',
		roleList: [
			{roleName: '开发区端',roleIcon: 'iconfont icon-icon-kaifaquduan',},
			{roleName: '园区端',roleIcon: 'iconfont icon-icon-yuanquduan',},
			{roleName: '企业端',roleIcon: 'iconfont icon-icon-qiyeduan',},
			{roleName: '用户端',roleIcon: 'iconfont icon-icon-yonghuduan',},
			{roleName: '第三方服务商',roleIcon: 'iconfont icon-icon-disanfangduan',},
		]
	},{
		serviceImg: 'static/images/solution/_d8ef889c0a.webp',
		serviceName: '统一企业服务和管理门户',
		serviceDetail: '整合园区现有各个业务系统，可利旧，可更新。企业需求一站式服务，一键触达，服务后台极速响应，提升服务效率和企业的满意度。',
		roleList: [
			{roleName: '企业服务门户',roleIcon: 'iconfont icon-icon-fuwumenhu',},
			{roleName: '服务管理后台',roleIcon: 'iconfont icon-icon-guanlihoutai',},
			{roleName: '集成管理中台',roleIcon: 'iconfont icon-icon-guanlizhongtai',},
		]
	},{
		serviceImg: 'static/images/solution/_b7da96d1cb.jpg',
		serviceName: '园区服务运营数智化',
		serviceDetail: '覆盖企业服务、产业服务、生活服务、物业服务在内的多种服务场景，沉淀服务经验，提升园区服务品质。',
		roleList: [
			{roleName: '活动申办',roleIcon: 'iconfont icon-icon-huodongshenban',},
			{roleName: '场地预约',roleIcon: 'iconfont icon-icon-changdiyuyue',},
			{roleName: '政策服务',roleIcon: 'iconfont icon-icon-zhengcefuwu',},
			{roleName: '项目申报',roleIcon: 'iconfont icon-icon-xiangmushenbao',},
			{roleName: '餐饮服务',roleIcon: 'iconfont icon-icon-canyingfuwu',},
			{roleName: '交通出行',roleIcon: 'iconfont icon-icon-jiaotongchuxing',},
			{roleName: '访客报备',roleIcon: 'iconfont icon-icon-fangkebaobei',},
			{roleName: '报事报修',roleIcon: 'iconfont icon-icon-baoshibaoxiu',},
		]
	},{
		serviceImg: 'static/images/solution/_591c25b68c.jpg',
		serviceName: '园区经营管理数智化',
		serviceDetail: '覆盖园区资产管理、招商管理、企业（客户）管理、财务管理、园区宣传等经营场景，赋能员工高效协同，提升经营组织效率。',
		roleList: [
			{roleName: '资产管理',roleIcon: 'iconfont icon-icon-zichan',},
			{roleName: '招商管理',roleIcon: 'iconfont icon-icon-zhaoshangguanli',},
			{roleName: '空间租赁',roleIcon: 'iconfont icon-icon-kongjianzuping',},
			{roleName: '企业档案管理',roleIcon: 'iconfont icon-icon-qiyedangan',},
			{roleName: '财务管理',roleIcon: 'iconfont icon-icon-caiwu',},
			{roleName: '园区官网',roleIcon: 'iconfont icon-icon-yuanquguanwang',},
			{roleName: '信息发布系统',roleIcon: 'iconfont icon-icon-xinxifabu',},
		]
	},{
		serviceImg: 'static/images/solution/_ed021c1118.jpg',
		serviceName: '园区综合运营管理数智化',
		serviceDetail: '集成Iot设备，覆盖安防管理、环境管理、通行管理、设施管理在内的多种运维管理业务，帮助提升园区综合运管效率。',
		roleList: [
			{roleName: '门禁管理',roleIcon: 'iconfont icon-icon-menjinguanli',},
			{roleName: '视频监控',roleIcon: 'iconfont icon-icon-shipinjiankong',},
			{roleName: '环境检测',roleIcon: 'iconfont icon-icon-huanjingjiance',},
			{roleName: '能耗管理',roleIcon: 'iconfont icon-icon-nenghaoguanli',},
			{roleName: '智慧停车',roleIcon: 'iconfont icon-icon-tingchechang',},
			{roleName: '设备维保',roleIcon: 'iconfont icon-icon-shebieweibao',},
			{roleName: '巡检巡更',roleIcon: 'iconfont icon-icon-xunjianxungeng',},
			{roleName: '报障处理',roleIcon: 'iconfont icon-icon-baozhangchuli',},
		]
	},{
		serviceImg: 'static/images/solution/_83e57fd015.jpg',
		serviceName: '园区数据决策中心',
		serviceDetail: '整合园区经营、园区服务、园区综合运管的数据沉淀，深度挖掘数据规律和分析数据趋势，为领导的决策提供数据支撑。',
		roleList: [
			{roleName: '园区经营大脑',roleIcon: 'iconfont icon-icon-yuanqujingyingdanao',},
			{roleName: '产业分析大屏',roleIcon: 'iconfont icon-icon-zhaoshangguanli',},
			{roleName: '企业成长分析',roleIcon: 'iconfont icon-icon-qiyechengzhang',},
			{roleName: 'BIM综合运维',roleIcon: 'iconfont icon-icon-BIMzonghe',},
		]
	},
]
export const caseWrapperList = [
	{
		imgUrl: 'static/images/solution/_661afcf94f.webp',
		caseName: '智慧园区',
		caseContent: '典型应用：设备维护、电梯运行、车辆管理、能效优化、共享仓库等',
	},{
		imgUrl: 'static/images/solution/8fe26a68-2fdf-4b6b-9503-a15dc9dbb660.png',
		caseName: '智慧医院',
		caseContent: '典型应用：智慧党建、停车管理、园区招商、企业服务、资产管理等',
	},{
		imgUrl: 'static/images/solution/_8e47a2e05d.png',
		caseName: '智慧商场',
		caseContent: '典型应用：环境监测、能效优化、停车服务、货物库存等',
	},{
		imgUrl: 'static/images/solution/_d29761b40b.jpg',
		caseName: '智慧社区',
		caseContent: '典型应用：政务服务办理、基层治理、人员监测等',
	},{
		imgUrl: 'static/images/solution/_e5a8ee82a6.jpg',
		caseName: '智慧开发区',
		caseContent: '典型应用：健康信息管理、空气监测、人员定位系统、物料追踪系统等',
	},{
		imgUrl: 'static/images/solution/_d6cc3f9034.jpg',
		caseName: '智慧校园',
		caseContent: '典型应用：安全用电、应急疏散、环境监测、食品追踪等',
	}
]


// WEBPACK FOOTER //
// ./src/components/solution/data.js